/* @flow */

import formSerialize from 'form-serialize';
import { type FormularioContato } from '../../empresa/types';

const getDadosFormulario = (form: HTMLElement) => formSerialize(form, { hash: true, empty: true });

export const getDadosFormularioContatos = (form: HTMLElement): FormularioContato[] => {
    const dados = formSerialize(form, { hash: true, empty: true });
    return Object.keys(dados).map(key => dados[key]);
};

export default getDadosFormulario;
